( function ( $ ) {

    if ( ! $('form.library-search-form').length ) { return; }

    let $form,
        $search_field,
        $type_select,
        $type_select_display,
        $selected_type,
        $type_select_list,
        $type_select_options;

    function set_element_vars () {
        $form = $( 'form.library-search-form' );
        $type_select = $( 'select.search-type', $form );
        $search_field = $( '#library-search-input', $form );
        $type_select_display = $( '.search-type-display', $form );
        $selected_type = $( '.selected-type', $type_select_display );
        $type_select_list = $( '.type-options', $type_select_display );
        $type_select_options = $( '.type-option', $type_select_list );
    }

    function submit_form ( e ) {
        e.preventDefault();
        let url;
        let search_term = $search_field.val().trim();
        url = $type_select.val().replace( '[SEARCH_TERM]', encodeURIComponent( search_term ) );
        window.open( url );
    }

    $(function () {
        set_element_vars();

        $type_select_display.click( () => $type_select_list.fadeToggle() );
        $type_select_options.click( function () {
            $type_select_options.removeClass( 'active' );
            $(this).addClass( 'active' );
            $selected_type.html( $(this).html() );
            $type_select[0].selectedIndex = $(this).index();
            $type_select.change();
        });

        $form.submit( submit_form );
    });

})( jQuery );